var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47656 7.75C9.32031 7.75 9.97656 8.40625 9.97656 9.25C9.97656 10.0703 9.29688 10.75 8.47656 10.75C7.63281 10.75 6.97656 10.0703 6.97656 9.25C6.97656 8.40625 7.63281 7.75 8.47656 7.75ZM8.5 4C10.1406 4 11.7109 4.60938 12.9531 5.6875C13.2578 5.96875 13.3047 6.4375 13.0234 6.76562C12.8594 6.92969 12.6719 7 12.4609 7C12.2734 7 12.1094 6.95312 11.9688 6.8125C11.0078 5.96875 9.76562 5.5 8.5 5.5C7.21094 5.5 5.96875 5.96875 5.00781 6.8125C4.70312 7.09375 4.23438 7.07031 3.95312 6.76562C3.69531 6.4375 3.71875 5.96875 4.02344 5.6875C5.26562 4.58594 6.83594 4 8.5 4ZM15.7656 3.17969C16.0469 3.46094 16.0703 3.95312 15.7891 4.23438C15.625 4.39844 15.4375 4.46875 15.25 4.46875C15.0625 4.46875 14.875 4.39844 14.7109 4.25781C13.0234 2.64062 10.8203 1.75 8.5 1.75C6.15625 1.75 3.92969 2.64062 2.26562 4.25781C1.96094 4.5625 1.49219 4.53906 1.1875 4.23438C0.90625 3.95312 0.929688 3.46094 1.21094 3.17969C3.17969 1.30469 5.75781 0.25 8.5 0.25C11.2188 0.25 13.7969 1.30469 15.7656 3.17969Z",
    fill: "#FF940A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.b52a37cc263f8884f9054909c3099029.svg";
export { ForwardRef as ReactComponent };